import {
  removeToken,
  removeUsername,
  removeTokentype,
  removeAuthKey,
  removeMobile,
} from '@/utils/cookies';
import bus from 'vue3-eventbus';

/**
 * 清除本地 cookie 登录态
 */
export function clearAuthCookies() {
  removeToken();
  removeUsername();
  removeTokentype();
  removeAuthKey();
  removeMobile();
}

/**
 * 清除本地登录态（含 vuex，延迟加载 store 避免循环依赖）
 */
export function clearAuthSession() {
  clearAuthCookies();
  import('@/store').then(({ store }) => {
    store.commit('user/CLEAR_USER_SESSION');
    store.commit('user/SET_AUTHTICATE', false);
  });
}

/**
 * 弹出登录对话框
 */
export function showLoginDialog(options = {}) {
  const {
    showMobile = false,
    showQrcode = false,
    showLogin = true,
  } = options;
  bus.emit('showLoginDialog', true);
  bus.emit('showLoginDialogMobile', showMobile);
  bus.emit('showLoginDialogQrcode', showQrcode);
  bus.emit('showLoginDialogLogin', showLogin);
}

/**
 * 弹出绑手机对话框
 */
export function showBindMobileDialog() {
  showLoginDialog({ showMobile: true, showLogin: false, showQrcode: false });
}

/**
 * 清登录态并弹登录框
 */
export function logoutAndShowLogin(message) {
  clearAuthSession();
  showLoginDialog({ showLogin: true });
  if (message) {
    ElMessage({
      message,
      grouping: true,
      type: 'warning',
    });
  }
}
